import React from 'react'
import {Route, Routes, Outlet} from 'react-router-dom'
import ActivityListWrapper from './activity/ListWrapper'
import AuthListWrapper from './auth/ListWrapper'

const LogPage = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route path='/auth' element={<AuthListWrapper />} />
      <Route path='/activity' element={<ActivityListWrapper />} />
    </Route>
  </Routes>
)

export default LogPage
